(function() {
    angular.module('tmx-app').directive('multiLine',['$timeout', function($timeout) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/multiline/multiline.html',
            scope:
            {
                label:"@",
                maxlength:"@",
                disabled:"=",
                value:"=",
                descriptionmodel:"@",
                ngchange:"=",
                required:"=",
                onChange:'&',
                dynamicField:'=',
              /*  cantfocus:"=",
                fieldname:"@"*/
            }
            ,
            controller: function($scope,$http) {

                $scope.saveclicked=false;
                // $scope.obj={};
                // $scope.obj.model="";
                $scope.txtmodel = $scope.value ? $scope.value.replace(/\n/g, " ") : $scope.value;
                $scope.$watch(function(){return $scope.value;},function(newVal,oldVal){
                    if(newVal != oldVal){
                        $scope.txtmodel = $scope.value ? $scope.value.replace(/\n/g, " ") : $scope.value;
                        $scope.onChange({ value: $scope.value, scope: $scope });
                    }
                });
                $scope.expanded=false;
                //if($scope.txtmodel!=null && $scope.txtmodel!="") { $scope.obj.model=$scope.txtmodel; }

                $('body').click(function(evt){
                    if(evt.target!=null) {
                        if (evt.target.id == "areaid") {
                        }
                        else if (evt.target.offsetParent!=null && evt.target.offsetParent.id == "multisave" || evt.target.id == "multisave") {
                            $scope.desc_save();
                            $scope.$apply();
                        }

                        else {
                            $scope.expanded = false;
                            $scope.$apply();
                        }
                    }
                    //For descendants of menu_content being clicked, remove this check if you do not want to put constraint on descendants.
                 /*   if($(evt.target).closest('#menu_content').length)
                        return;*/
                    //Do processing of click event here for every element except with id menu_content

                });

                $scope.desc_save=function() {
                    //$scope.txtmodel=$scope.obj.model;
                    $scope.expanded=false;
                }

                $scope.desc_cancel=function() {
                    $scope.expanded=false;
                }

/*
                $scope.blurfunc=function()
                {
                    if($scope.saveclicked) {  $scope.txtmodel=$scope.obj.model;
                    $scope.expanded=false; }
                    else
                    {  $scope.expanded=false; }
                }*/

            },

            link: function (scope, element, attrs,ngModel) {
                scope.txt_focused=function() {
                    // if(scope.txtmodel!=null) scope.obj.model=scope.txtmodel;
                    // else scope.obj.model="";
                    scope.expanded=true;
                    $timeout(function() {
                        element.find("textarea").focus();
                    });
                }
            }

        };
    }]);
})();